import {Component} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import "rxjs/add/observable/fromPromise";
import {Observable} from "rxjs/Observable";
import {DisposalsService} from "../../../../services/disposals.service";
import {CalendarEvent} from "../calendar-event";

@Component({
  selector: 'remove-disposal-modal',
  templateUrl: 'remove-disposal-modal.component.html'
})
export class RemoveDisposalModalComponent {
  calendarEvent: CalendarEvent;

  static open(modalService: NgbModal, calendarEvent: CalendarEvent): Observable<boolean> {
    const modalRef = modalService.open(RemoveDisposalModalComponent);
    modalRef.componentInstance.calendarEvent = calendarEvent;
    return Observable.fromPromise(modalRef.result);
  }

  constructor(private activeModal: NgbActiveModal, private disposalService: DisposalsService) {
  }

  close() {
    this.activeModal.close(false);
  }

  submit() {
    this.disposalService.removeDisposal(this.calendarEvent.originalEvent.origin_id).subscribe(
      () => this.activeModal.close(true)
    );
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/calendar/modals/remove-disposal-modal.component.ts